import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';

function RoadMap() {
    const location = useLocation();
    const roadRef = useRef(null);
    useEffect(() => {
      const scrollToRef = (ref) => {
        if (ref.current) {
          ref.current.scrollIntoView({ behavior: "smooth" });
        }
      };
      switch (location.hash) {
        case "#roadmap":
          scrollToRef(roadRef);
          break;
        default:
          break;
      }
    }, [location.hash]);

    
  return (
    <>
      <section className="  pb-4 pb-md-5 mt-5 bg-black scotty" ref={roadRef}>
        <div className="container">
          <div className="row ">
            <div className="col-md-12 m-auto">
              <div className="text-center mb-4">
                <h2 className="hadding hadding_bg text-center mb-0 d-inline-block" data-aos="fade-up">
                  Scotty V2 Plan
                </h2>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="sscotty_box_1 h100">
                    <div className="sscotty_box h100">
                      <h5 className="phase-one">
                        Phase 1: <b>Booting Up V2</b>
                      </h5>
                      <ul className="check-add">
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Announce Scotty V2 – The hype begins.
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Community Building – The Scotty Army assembles.
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Whitepaper Release – You’re reading it.
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Presale Launch – Get in early, degen.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="sscotty_box_1 h100">
                    <div className="sscotty_box h100">
                      <h5 className="phase-one">
                        Phase 2: <b>Lift-Off</b>
                      </h5>
                      <ul className="check-add">
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          $SCOTTY Live on Solana
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> DEX
                          Liquidity Boost – Clean trades, no slippage
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> Viral
                          Marketing – AI-powered memes incoming
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> First
                          CEX Listings – More access, bigger gains
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="sscotty_box_1 h100">
                    <div className="sscotty_box h100">
                      <h5 className="phase-one">
                        Phase 3: <b>Full-Scale Domination</b>
                      </h5>
                      <ul className="check-add">
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          AI-Powered Insights – Holders get exclusive trading
                          tools
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> Scotty
                          NFT Drop – Memes meet collectibles
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Community Airdrops & Rewards – Loyalty pays
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Governance Voting – The community decides
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="sscotty_box_1 h100">
                    <div className="sscotty_box h100">
                      <h5 className="phase-one">
                        Phase 4: <b>Full-Scale Domination</b>
                      </h5>
                      <ul className="check-add">
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> Major
                          Partnerships – Scotty goes mainstream
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Metaverse Integration – AI memes in the digital world
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" />{" "}
                          Cross-Chain Expansion – Why stop at Solana?
                        </li>
                        <li>
                          <img src="/assets/img/check.png" alt="check" /> More
                          CEX Listings – The world needs $SCOTTY
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default RoadMap